export const LIMITS = {
	PATH_MAX_LENGTH: 500,
	FILE_MAX_SIZE: 5 * 1024 * 1024, // 5MB
	SESSION_ID_MAX_LENGTH: 32,
	SNAPSHOT_ID_MAX_LENGTH: 64,
	TITLE_MAX_LENGTH: 100,
} as const;
